import addComponentLoader, { importWithRetry } from '@/utils/component-loader'
import { defineAsyncComponent } from 'vue'

const discussionForumComponentMapping = {
  eventDiscussionForumLoader: defineAsyncComponent(() => importWithRetry(() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "event-discussion-forum-loader" */ '@/events/discussion-forum-loader'))),
  groupDiscussionForumContainer: defineAsyncComponent(() => importWithRetry(() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "group-discussion-forum-loader" */ './local-chapters/discussion-forum-container')))
}

const discussionForumThreadComponentMapping = {
  groupDiscussionForumThreadContainer: defineAsyncComponent(() => importWithRetry(() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "group-discussion-forum-thread-container" */ './local-chapters/discussion-forum-thread-container')))
}

addComponentLoader(discussionForumComponentMapping, {}, () => importWithRetry(() => import(/* webpackChunkName: "discussion-forum-store-getter" */ './common/store/forum')))
addComponentLoader(discussionForumThreadComponentMapping, {}, () => importWithRetry(() => import(/* webpackChunkName: "discussion-forum-thread-store-getter" */ './common/store/thread')))
